export default __webpack_public_path__ + "static/media/tabler-icon-pencil-minus.b9d74996.svg";